import { ViewMode } from 'app/area/code-selector/types';
import { CodetableWireFormat } from 'app/infrastructure/ui/form/types-codetable';

export const ACTION = {
  RequestCodes: 'CODE_SELECTOR:REQUEST_CODES',
  ReceiveCodes: 'CODE_SELECTOR:RECEIVE_CODES',
  RequestBookmarkedCodes: 'CODE_SELECTOR: REQUEST_BOOKMARKED_CODES',
  ReceiveBookmarkedCodes: 'CODE_SELECTOR: RECEIVE_BOOKMARKED_CODES',
  ChangeViewModeCaseTypes: 'CODE_SELECTOR: CHANGE_VIEW_MODE_CASE_TYPES'
};

export class RequestCodes {
  public type: string = ACTION.RequestCodes;
}

export class ReceiveCodes {
  public type: string = ACTION.ReceiveCodes;
  public codes: CodetableWireFormat[];

  constructor(codes: CodetableWireFormat[]) {
    this.codes = codes;
  }
}
export class RequestBookmarkedCodes {
  public type: string = ACTION.RequestBookmarkedCodes;
}
export class ReceiveBookmarkedCodes {
  public type: string = ACTION.ReceiveBookmarkedCodes;
  public bookmarkedCodes: CodetableWireFormat[];

  constructor(bookmarkedCodes: CodetableWireFormat[]) {
    this.bookmarkedCodes = bookmarkedCodes;
  }
}
export class ChangeViewModeCaseTypes {
  public type: string = ACTION.ChangeViewModeCaseTypes;
  public mode: ViewMode;

  constructor(mode: ViewMode) {
    this.mode = mode;
  }
}
